module.exports = __webpack_public_path__ + "img/property.a87555b8.webp";